import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { mediaCSS, textSizes } from 'theme/media'
import { colors, IStyles } from '../../../theme'
import { color } from 'theme/tokens/color'

const deviceSettingsKioskModeStyles: IStyles = {
    title: {
        fontSize: textSizes.normal,
    },
    switchWrapper: {
        display: 'flex',
        paddingBottom: 20,
    },
    switchCaption: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 14,

        span: {
            marginRight: 6,
        },
    },
    hint: {
        fontSize: textSizes.mini,
        color: color.fontDarkMedium,
        ...grid.mb_md,
        marginTop: 8,
    },
    error: {
        color: colors.errorSaturated,
        borderColor: colors.errorSaturated,
    },
    radioWrapper: {
        ...grid.row,
        ...grid.fullWidth,
    },
    radio: {
        ...grid.mr_md,
    },
    inputWrapper: {
        ...grid.w25,
        [mediaCSS.tab]: {
            ...grid.w50,
        },
        [mediaCSS.tabMini]: {
            ...grid.w100,
        },
    },
    maskedInput: {
        WebkitTextSecurity: 'disc',
        textSecurity: 'disc',
    },
}

addStyles(deviceSettingsKioskModeStyles)
export default deviceSettingsKioskModeStyles
